import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast__notifier" }
const _hoisted_2 = { class: "toast__text" }
const _hoisted_3 = {
  class: "toast__header",
  "data-test": "header-toast"
}
const _hoisted_4 = {
  class: "toast__body",
  "data-test": "paragraph-toastBody"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "toast__close-icon icon-cross" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close notification", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toast", `toast--${_ctx.status}`]),
    role: "alert",
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pauseTimeout && _ctx.pauseTimeout(...args))),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startTimeout && _ctx.startTimeout(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", {
        class: _normalizeClass(["toast__icon", `icon-${_ctx.status === 'inform' || _ctx.status === 'success' ? 'tick' : 'exclamation'}`])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.header), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.body), 1)
    ]),
    _createVNode(_component_Btn, {
      onClick: _ctx.closeToast,
      class: "toast__close",
      ghost: "",
      title: "Close notification",
      "data-test": "button-closeToast"
    }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 34))
}